import MasterDataPage from "../common/MasterDataPage"
import { attributionsApi } from "../../../service/certificate"

// RMS models attributions as a plain name-only list (image/title/description
// were dropped as over-spec). Just name + active status.
const CertAttributions = () => (
  <MasterDataPage
    config={{
      title: "Attributions",
      subtitle: "Named attributes for certificates — e.g. 'Most Punctual', 'Best Behaviour', 'Sportsmanship Award'.",
      api: attributionsApi as any,
      columns: [{ title: "Name", dataIndex: "name" }],
      fields: [{ name: "name", label: "Name", required: true, placeholder: "e.g. Most Punctual, Best Behaviour" }],
    }}
  />
)

export default CertAttributions
